<template>
  <div class="header-news-component">
    <NuxtLink :to="getLocalizedRoute(Routes.Blog)">
      {{ blogTitle }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import { Routes } from '~/enums/Routes'

const { t } = useLang()
const blogTitle = computed(() => t('blog.blog'))
</script>

<style lang="postcss" scoped>
.header-news-component {
  @apply flex items-center text-sm text-text1 dark:text-dmText1;
}
</style>
